<div class="container" [ngSwitch]="mode">
  <form [formGroup]="qcForm" (ngSubmit)="onSubmit($event)" class="post">
    <div class="post" *ngSwitchCase="'add'">
      <div class="title">Create QC</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="Name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Unit</mat-label>
            <input formControlName="Unit" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Min</mat-label>
            <input
              formControlName="Min"
              matInput
              placeholder=""
              type="number"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Normal</mat-label>
            <input
              formControlName="Normal"
              matInput
              placeholder=""
              type="number"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Max</mat-label>
            <input
              formControlName="Max"
              matInput
              placeholder=""
              type="number"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Start Date</mat-label>
            <input
              formControlName="StartDate"
              matInput
              placeholder=""
              type="date"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Stop Date</mat-label>
            <input
              formControlName="StopDate"
              matInput
              placeholder=""
              type="date"
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Qc Values Count</mat-label>
            <input
              formControlName="QcValuesCount"
              matInput
              placeholder=""
              type="number"
            />
          </mat-form-field>
        </span>

        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
            <p>{{ Errors }}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
            <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading ? "Saving..." : "Save" }}
          </button>
        </div>
      </div>
    </div>
    <!-- <div *ngSwitchCase="'values'">
      <div class="title">Add Values QC</div>
      <button mat-raised-button color="primary" (click)="back()">Back</button
      ><br /><br />

      <span class="input">
        <mat-form-field>
          <mat-label>Test ID</mat-label>
          <input
            matInput
            placeholder=""
            type="text"
            [(ngModel)]="sampleId"
            [ngModelOptions]="{ standalone: true }"
          />
        </mat-form-field>
      </span>
      <span class="input">
        <mat-form-field>
          <mat-label>Params Name</mat-label>
          <input
            matInput
            placeholder=""
            type="text"
            [(ngModel)]="paramName"
            [ngModelOptions]="{ standalone: true }"
          />
        </mat-form-field>
      </span>
      <span class="input">
        <mat-form-field>
          <mat-label>Params Unit</mat-label>
          <input
            matInput
            placeholder=""
            type="text"
            [(ngModel)]="paramUnit"
            [ngModelOptions]="{ standalone: true }"
          />
        </mat-form-field>
      </span>
      <span class="input">
        <mat-form-field>
          <mat-label>Param Value</mat-label>
          <input
            matInput
            placeholder=""
            type="number"
            [(ngModel)]="paramValue"
            [ngModelOptions]="{ standalone: true }"
          />
        </mat-form-field>
      </span>
      <span class="input">
        <mat-form-field>
          <mat-label>Time Stamp</mat-label>
          <input
            matInput
            placeholder=""
            type="date"
            [(ngModel)]="timestamp"
            [ngModelOptions]="{ standalone: true }"
          />
        </mat-form-field>
        <div class="span-button" (click)="addValues()">Add</div>
      </span>

      <br /><br />
      <div class="table">
        <div
          class="service"
          *ngFor="let val of valuesCount"
          (click)="deleteItem(val.ParamName)"
        >
          {{ val.ParamName }} {{ val.ParamUnit }}<br />
          {{ val.ParamValue }}<br />
        </div>
      </div>
      <br />
    </div> -->
  </form>
</div>
